var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/mapStateToActionHandlers.ts
import { omit } from "lodash";
import { push } from "connected-react-router";
var onStoreFunction = (value, store, args) => store.dispatch(value.type === "@vf-dcl/dynamic-journey-renderer/LOCATION_CHANGE" ? push(typeof value.payload === "string" ? value.payload : __spreadValues(__spreadValues({}, store.getState().router.location), value.payload)) : __spreadProps(__spreadValues({}, value), {
  payload: __spreadProps(__spreadValues({}, value.payload || {}), {
    dj$arguments: args
  })
}));
var mapStateToActionHandlersPlugin = (_a, Element, { store, analyticsHandler } = {}) => {
  var _b = _a, { __component, __props = {} } = _b, paths = __objRest(_b, ["__component", "__props"]);
  if (!store) {
    console.error("Missing one or more initialisation properties for the Map State To Action Handlers Plugin");
    return __props;
  }
  const processableProps = __component ? omit(__props, "children") : paths;
  return Object.entries(processableProps).reduce((props, [prop, value]) => __spreadProps(__spreadValues({}, props), {
    [prop]: (() => {
      switch (true) {
        case prop.startsWith("on"):
          return (...args) => {
            if (analyticsHandler && Array.isArray(value.analytics) && value.analytics.length) {
              return analyticsHandler(...value.analytics).then(onStoreFunction(value, store, args));
            }
            return onStoreFunction(value, store, args);
          };
        default:
          return value;
      }
    })()
  }), {});
};
var mapStateToActionHandlers_default = mapStateToActionHandlersPlugin;

// src/index.ts
var src_default = mapStateToActionHandlers_default;
export {
  src_default as default
};
